export default __webpack_public_path__ + "static/media/568.d2a8cca3.png";